import { useGetDefaultESignQuery } from '@/store/query/e-signs';
import {
  ESIGNATURE_PROVIDERS,
  ESIGN_DEFAULT_PURPOSE,
} from '@/constants/esignature';
import type { EsignActivityConfig } from '@/types/esignature';

interface UseEsignStageDefaultArgs {
  jobId?: string | number;
  /** Create only — an existing activity has its own saved subject and body. */
  enabled: boolean;
}

/**
 * The account's default e-sign email, for a brand-new activity only.
 *
 * `purpose` matters: without it the backend returns the OFFER default, whose
 * tokens do not exist in the stage render context — offer copy with blanks in
 * it, on what is usually an NDA. Wrong copy, no error.
 */
export const useEsignStageDefault = ({
  jobId,
  enabled,
}: UseEsignStageDefaultArgs) => {
  const { data, isFetching } = useGetDefaultESignQuery(
    {
      integration_type: ESIGNATURE_PROVIDERS.DOCUSIGN,
      purpose: ESIGN_DEFAULT_PURPOSE.STAGE,
      ...(jobId ? { job_id: jobId } : {}),
    },
    { skip: !enabled }
  );

  return {
    stageDefault: enabled
      ? (data as EsignActivityConfig | undefined)
      : undefined,
    isLoadingDefault: enabled && isFetching,
  };
};
